// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"styles_loadingSpinner__KpI94","spin":"styles_spin__SWFPu"};